import { memo } from 'react';
import { TDbOrderHistory } from '@shared/types/db/order_history';
import { NATIVE_SOL, NATIVE_ADDRESS, WRAPPED_SOL, ZERO_ADDRESS } from '@shared/utils/config/networks';
import { useRouter } from 'next/router';
import { stableCoins } from '@/components/explore/stableCoins';
import ImageWithFallback from '@/components/shared/ImageWithFallback';
import { Button } from '@/components/ui/button';
import { useSwap } from '@/contexts/SwapProvider';
import classNames from '@/lib/misc/classNames';
import { addressMappings } from '@/lib/asset/nativeAddressHelper';
import { toSpecialFixed } from '@/lib/misc/utils';
const BuySellPeople = memo(({
  order
}: {
  order: TDbOrderHistory;
}) => {
  const {
    resetAssets
  } = useSwap();
  const settledTokensOut = order.settled_tokens_out;
  const maxTokenOut = settledTokensOut.find(x => {
    const maxAmount = settledTokensOut.reduce((prev, current) => prev.usd_value > current.usd_value ? prev : current);
    return x.usd_value === maxAmount.usd_value;
  });
  const router = useRouter();
  const isSell = () => {
    const network = maxTokenOut?.network;
    const lowercasedAddress = maxTokenOut?.token_address?.toLowerCase();
    //natives
    if (lowercasedAddress === WRAPPED_SOL?.toLowerCase()) return true;
    if (lowercasedAddress === NATIVE_SOL?.toLowerCase()) return true;
    if (lowercasedAddress == NATIVE_ADDRESS?.toLowerCase()) return true;
    if (lowercasedAddress == ZERO_ADDRESS?.toLowerCase()) return true;
    //wrapped
    if (addressMappings[network]?.address === lowercasedAddress) return true;
    //stables
    if (stableCoins.some(x => {
      if (x.tokens[network]?.toLowerCase() === lowercasedAddress) return true;
    })) return false;
  };
  const tokenInfo = order?.token_out_prices?.find(x => x?.token?.address?.toLowerCase() === maxTokenOut?.token_address?.toLowerCase());
  const tokenInInfo = order?.token_prices?.tokensIn?.[0];
  const tokensIn = order?.token_prices?.tokensIn;
  const tokensInUSDValue = tokensIn?.reduce((acc, token) => {
    const formattedAmount = token?.amountToUse * parseFloat(token.quote_rate?.toString());
    return acc + formattedAmount;
  }, 0);
  function shortName(str: string) {
    const maxLength = 13; // Set the desired maximum length
    if (str.length <= maxLength) {
      return str; // No need to truncate if the string is already short
    }
    return str.substring(0, maxLength) + '...';
  }
  return <div onClick={() => {
    resetAssets();
    router.push(`/asset?address=${maxTokenOut.token_address}&networkId=${maxTokenOut?.network}&tradeSide=buy`);
  }}>
      <div className='flex justify-between items-center w-full h-[70px]'>
        <div className='flex items-center'>
          {' '}
          <ImageWithFallback src={'/static/genie/' + order.pfp} className='w-[34px] h-[34px] ml-2 rounded-full' alt='order' width={34} height={34} />
          <div className='flex flex-col items-start justify-start ml-4'>
            <p className='text-[16px] flex items-center text-genius-cream'>
              {shortName(order.first_name)}
              <span className='text-genius-cream/50 text-[10px] ml-2'>
                {(() => {
                const result = new Date(order.created_at).toLocaleDateString('en-US', {
                  year: 'numeric',
                  month: 'short',
                  day: 'numeric',
                  hour: 'numeric',
                  minute: 'numeric'
                });
                return result;
              })()}{' '}
              </span>
            </p>
            <div className='flex items-center text-[12px] space-x-1 flex-wrap'>
              {' '}
              <p className={classNames('text-genius-cream ', isSell() ? 'text-[#F87171]' : 'text-[#34D399]')}>
                <span>{isSell() ? 'Sold' : 'Bought'}</span>
              </p>
              <p className='text-genius-cream/50'>
                {' '}
                ${toSpecialFixed(tokensInUSDValue, 2).value} of
              </p>
              <p> {isSell() ? tokenInInfo?.contract_ticker_symbol : tokenInfo?.token?.symbol}</p>
              <ImageWithFallback src={isSell() ? tokenInInfo?.logo_url : tokenInfo?.token?.info?.imageThumbUrl} alt={tokenInfo?.token?.symbol} width={16} height={16} className='rounded-full ml-[10px!important]' />
            </div>
          </div>
        </div>

        <div className='flex items-center justify-end space-x-1'>
          <Button className={'w-[71px] h-[36px] text-[14px] text-genius-cream rounded-[8px] bg-genius-blue hover:bg-genius-pink hover:text-genius-blue transition-colors'}>
            Trade
          </Button>
        </div>
      </div>
    </div>;
});
export default BuySellPeople;
BuySellPeople.displayName = 'BuySellPeople';